/**
 * product-tabs.js
 * ---------------------------------------------------------------------------
 * Troca de abas das linhas recolhíveis da PDP (Descrição completa, Modo de
 * uso, Composição) — clicar numa aba mostra o conteúdo dela e esconde os
 * outros. Mesmo padrão do vitrine-tabs.js, sem dependências.
 * ---------------------------------------------------------------------------
 */
document.addEventListener('click', function (event) {
  const tab = event.target.closest('[data-product-tab]');
  if (!tab) return;

  const wrapper = tab.closest('.product-tabs');
  if (!wrapper) return;

  const targetId = tab.getAttribute('data-product-tab');
  const wasActive = tab.classList.contains('active');

  wrapper.querySelectorAll('.product-tabs__tab').forEach((btn) => {
    const isActive = btn === tab && !wasActive;
    btn.classList.toggle('active', isActive);
    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  wrapper.querySelectorAll('.product-tabs__panel').forEach((panel) => {
    const isActive = panel.id === targetId && !wasActive;
    panel.classList.toggle('active', isActive);
    if (isActive) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });
});